import { MutationTree } from 'vuex'

import { QuestionnaireAnswerState } from '@/types/store'
import { QuestionnaireAnswerEntity } from '../../../api/@types'
import { IReceipt } from '@/types/receipt'

export const mutations: MutationTree<QuestionnaireAnswerState> = {
  setIsQuestionnaireAnswerLoading(state, isLoading: boolean) {
    state.isQuestionnaireAnswerLoading = isLoading
  },
  questionnaireAnswerLoaded(
    state,
    questionnaireAnswers: QuestionnaireAnswerEntity[],
  ) {
    state.questionnaireAnswers = questionnaireAnswers
  },
  setQuestionnaireAnswer(
    state,
    questionnaireAnswer: QuestionnaireAnswerEntity,
  ) {
    state.questionnaireAnswer = questionnaireAnswer
  },
  setQuestionnaireAnswerReceipt(state, receipt: IReceipt) {
    state.receipt = receipt
  },
}
